<!-- <app-nav></app-nav> -->
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">
<app-nav></app-nav>
<div class="main container mt-4">

    <app-top-bar></app-top-bar>
    <router-outlet></router-outlet>
    
</div>